import { all } from 'redux-saga/effects';
import profileSaga from '@iso/redux/profile/saga';

export default function* rootSaga(getState) {
  yield all([profileSaga()]);
}
